module.exports = __webpack_public_path__ + "static/7-810788c1f543b7a16e6ec0929b78cb91.jpeg";